import {MouseEvent, PropsWithChildren} from "react";
import {css, cx} from "@panda/css";

import {getEnterExitClass} from "../bottom_sheet";
import {
    popupPanelFadeInStyle,
    popupPanelFadeOutStyle,
    popupPanelMotionEnterStyle,
    popupPanelMotionExitStyle,
    popupPanelOverlayFadeInStyle,
    popupPanelOverlayFadeOutStyle
} from "./styles/popup_panel_motion";

interface IProps extends PropsWithChildren {
    ariaLabel?: string;
    className?: string;
    dataTestId?: string;
    isClosing: boolean;
    isEntering: boolean;
    onClose: () => void;
    role?: string;
    zIndex: number;
}

export const PopupPanel = (props: IProps) => {
    const {ariaLabel, children, className, dataTestId, isClosing, isEntering, onClose, role, zIndex} = props;

    const motionTimingStyle = getEnterExitClass(isClosing, isEntering, popupPanelMotionEnterStyle, popupPanelMotionExitStyle);
    const panelFadeStyle = getEnterExitClass(isClosing, isEntering, popupPanelFadeInStyle, popupPanelFadeOutStyle);
    const overlayFadeStyle = getEnterExitClass(isClosing, isEntering, popupPanelOverlayFadeInStyle, popupPanelOverlayFadeOutStyle);

    const handleOverlayClick = (event: MouseEvent<HTMLDivElement>) => {
        event.stopPropagation();
        onClose();
    };

    const handlePanelClick = (event: MouseEvent<HTMLDivElement>) => {
        event.stopPropagation();
    };

    return (
        <>
            <div className={cx(popupPanelOverlayStyle, motionTimingStyle, overlayFadeStyle)} onClick={handleOverlayClick} style={{zIndex}} />
            <div
                aria-label={ariaLabel}
                className={cx(popupPanelStyle, motionTimingStyle, panelFadeStyle, className)}
                data-testid={dataTestId}
                onClick={handlePanelClick}
                role={role}
                style={{zIndex}}
            >
                {children}
            </div>
        </>
    );
};

const popupPanelOverlayStyle = css({
    inset: 0,
    position: "fixed",
    backgroundColor: "var(--colors-overlay)"
});

const popupPanelStyle = css({
    position: "absolute",
    backgroundColor: "var(--colors-white)",
    borderRadius: 2,
    boxShadow: "var(--shadow-1)",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    maxWidth: "90vw"
});
import {MouseEvent, PropsWithChildren} from "react";
import {css, cx} from "@panda/css";

import {getEnterExitClass} from "../bottom_sheet";
import {
    popupPanelFadeInStyle,
    popupPanelFadeOutStyle,
    popupPanelMotionEnterStyle,
    popupPanelMotionExitStyle,
    popupPanelOverlayFadeInStyle,
    popupPanelOverlayFadeOutStyle
} from "./styles/popup_panel_motion";

interface IProps extends PropsWithChildren {
    ariaLabel?: string;
    className?: string;
    dataTestId?: string;
    isClosing: boolean;
    isEntering: boolean;
    onClose: () => void;
    role?: string;
    zIndex: number;
}

export const PopupPanel = (props: IProps) => {
    const {ariaLabel, children, className, dataTestId, isClosing, isEntering, onClose, role, zIndex} = props;

    const motionTimingStyle = getEnterExitClass(isClosing, isEntering, popupPanelMotionEnterStyle, popupPanelMotionExitStyle);
    const panelFadeStyle = getEnterExitClass(isClosing, isEntering, popupPanelFadeInStyle, popupPanelFadeOutStyle);
    const overlayFadeStyle = getEnterExitClass(isClosing, isEntering, popupPanelOverlayFadeInStyle, popupPanelOverlayFadeOutStyle);

    const handleOverlayClick = (event: MouseEvent<HTMLDivElement>) => {
        event.stopPropagation();
        onClose();
    };

    const handlePanelClick = (event: MouseEvent<HTMLDivElement>) => {
        event.stopPropagation();
    };

    return (
        <>
            <div className={cx(popupPanelOverlayStyle, motionTimingStyle, overlayFadeStyle)} onClick={handleOverlayClick} style={{zIndex}} />
            <div
                aria-label={ariaLabel}
                className={cx(popupPanelStyle, motionTimingStyle, panelFadeStyle, className)}
                data-testid={dataTestId}
                onClick={handlePanelClick}
                role={role}
                style={{zIndex}}
            >
                {children}
            </div>
        </>
    );
};

const popupPanelOverlayStyle = css({
    inset: 0,
    position: "fixed",
    backgroundColor: "var(--colors-overlay)"
});

const popupPanelStyle = css({
    position: "absolute",
    backgroundColor: "var(--colors-white)",
    borderRadius: 2,
    boxShadow: "var(--shadow-1)",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    maxWidth: "90vw"
});
